var map = {
	"./ar.json": [
		25896,
		25896
	],
	"./en.json": [
		60414,
		60414
	],
	"./es.json": [
		70749,
		70749
	],
	"./fa.json": [
		70980,
		70980
	],
	"./fil.json": [
		93711,
		93711
	],
	"./hi.json": [
		34366,
		34366
	],
	"./hy.json": [
		7380,
		7380
	],
	"./ja.json": [
		79788,
		79788
	],
	"./km.json": [
		99882,
		99882
	],
	"./ko.json": [
		41414,
		41414
	],
	"./ru.json": [
		95334,
		95334
	],
	"./th.json": [
		81488,
		81488
	],
	"./uk.json": [
		78212,
		78212
	],
	"./ur.json": [
		74708,
		74708
	],
	"./vi.json": [
		10954,
		10954
	],
	"./zh_CN.json": [
		491,
		491
	],
	"./zh_TW.json": [
		54937,
		54937
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 95927;
module.exports = webpackAsyncContext;